import { Segmented } from 'components/ui/Segmented'
import { Spinner } from 'components/ui/States'
import { FC } from 'react'

interface IDateRangeBar {
    from: string
    to: string
    quickDays: number[]
    activeDays?: number
    isFetching?: boolean
    onSelectDays: (days: number) => void
    onChangeFrom: (value: string) => void
    onChangeTo: (value: string) => void
}

/** Global date-range bar (section E). Sticky below the nav on desktop. */
export const DateRangeBar: FC<IDateRangeBar> = ({ from, to, quickDays, activeDays, isFetching, onSelectDays, onChangeFrom, onChangeTo }) => (
    <div data-print-static className='z-30 -mx-4 bg-canvas px-4 py-2 sm:-mx-6 sm:px-6 lg:sticky lg:top-16 lg:-mx-8 lg:px-8'>
        <div className='card flex flex-col gap-3 p-3 sm:flex-row sm:flex-wrap sm:items-end sm:justify-between sm:p-4'>
            <div className='flex flex-col gap-1.5'>
                <span className='flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs font-medium text-ink-muted'>
                    分析期間
                    {isFetching && <Spinner className='h-3 w-3' />}
                    <span className='font-normal text-ink-faint'>以下數據按所選期間計算</span>
                </span>
                <Segmented
                    ariaLabel='快速選擇期間'
                    className='w-full sm:w-auto'
                    options={quickDays.map((days) => ({ value: days, label: `過去${days}日` }))}
                    value={activeDays}
                    onChange={onSelectDays} />
            </div>
            <div className='grid grid-cols-2 gap-2 sm:flex sm:items-end sm:gap-3'>
                <label className='flex min-w-0 flex-col gap-1.5'>
                    <span className='text-xs font-medium text-ink-muted'>由</span>
                    <input
                        type='date'
                        aria-label='開始日期'
                        value={from}
                        max={to}
                        onChange={(e) => onChangeFrom(e.currentTarget.value)}
                        className='input min-w-0 tabular-nums sm:w-44' />
                </label>
                <label className='flex min-w-0 flex-col gap-1.5'>
                    <span className='text-xs font-medium text-ink-muted'>至</span>
                    <input
                        type='date'
                        aria-label='結束日期'
                        value={to}
                        min={from}
                        onChange={(e) => onChangeTo(e.currentTarget.value)}
                        className='input min-w-0 tabular-nums sm:w-44' />
                </label>
            </div>
        </div>
    </div>
)
